import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportClientError } from '@/services/observability/clientErrors';

type Props = { children: ReactNode };
type State = { hasError: boolean; error?: Error };

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    reportClientError(error, info.componentStack);
  }

  override render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ padding: 60, textAlign: 'center', color: 'var(--ink-2)' }}>
        <h1 style={{ fontFamily: 'var(--font-serif)' }}>Algo deu errado</h1>
        <p style={{ color: 'var(--ink-3)' }}>
          Atualize a página ou volte ao início.
        </p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => window.location.assign('/')}
        >
          Voltar ao início
        </button>
      </div>
    );
  }
}
